module.exports = __webpack_public_path__ + "img/instagram-black.1f429d1f.png";